import { combineReducers } from "redux";
import { customerReducer } from './customerReducer';

export const reducers = combineReducers({
    customer : customerReducer
});
